import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Tab, Tabs, TabList } from 'ui-component-library';

import Container, {
  TitleContainer,
  Title,
  TabsContainer,
} from './sub-navigation.style';
import theme from '../../../../theme';

import { APP_FEATURES, MODE_TYPES } from '../../../../constants';

import { setModeType } from '../../../../store/mode/slice';
import { clearSelectedLoad } from '../../../../store/selected-load/slice';
import useFeatureFlag from '../../../../hooks/use-feature-flag';

/**
 * Sub-navigation component
 * @return {element}
 */
const SubNavigation = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const modeType = useSelector((state) => state.modeType.type);
  const ltlFlag = useFeatureFlag(APP_FEATURES.LTL);

  const [selectedIndex, setSelectedIndex] = useState(modeType === MODE_TYPES.truckload ? 0 : 1);

  /**
   * Handles when the user clicks a tab in the subnavigation
   * @return {void}
   */
  const handleTabClicked = (type) => {
    dispatch(setModeType(type));
    dispatch(clearSelectedLoad());
    const currentSearchParams = new URL(document.location).searchParams;
    if (currentSearchParams.has('smartFilter')) {
      history.push(`/?modeType=${type}&smartFilter=${currentSearchParams.get('smartFilter')}`);
    } else {
      history.push(`/?modeType=${type}`);
    }
  };

  useEffect(() => {
    setSelectedIndex(modeType === MODE_TYPES.truckload ? 0 : 1);
  }, [modeType]);

  return (
    <Container>
      <TitleContainer>
        <Title>Track & Trace</Title>
      </TitleContainer>
      <TabsContainer>
        <Tabs
          selectedIndex={selectedIndex}
          onSelect={(index) => setSelectedIndex(index)}
        >
          <TabList
            width="275px"
            fontSize={theme.typography.sizes.h3}
            fontWeight={theme.typography.weight.bold}
            $uppercase
          >
            <Tab onClick={() => handleTabClicked(MODE_TYPES.truckload)}>Truckload Tracking Queue</Tab>
            {ltlFlag && <Tab onClick={() => handleTabClicked(MODE_TYPES.lessThanTruckload)}>LTL Tracking Queue</Tab>}
          </TabList>
        </Tabs>
      </TabsContainer>
    </Container>
  );
};

export default SubNavigation;
